<template>
  <div class="set-title">
    <el-dialog
        title="一键下单"
        :visible="true"
        @close="handleClose"
        width="660px"
    >
      <div class="box">
        <div class="left">
          <img :src="info.picUrl" alt="">
        </div>
        <div class="right">
          <p>{{ info.goodsName }}</p>
          <div v-for="(item, index) in info.specificationList" :key="index">
            <div class="" style="display: flex;">
              <div style="margin-top: 5px;">{{item.name}}：</div>
              <div style="display: flex;align-items: center;flex-wrap: wrap;flex: 1;">
                <div
                    v-for="(v,i) in item.value"
                    :key="i"
                >
                  <div v-if="v.url">
                    <img
                        :class="v.checked === '1' ? 'img1 active' : 'img1'"
                        @click="handleGG(item, v, i)"
                        :src="v.url"
                        alt=""
                    >
                  </div>
                  <div v-else>
                    <div
                        :class="v.checked === '1' ? 'text active' : 'text'"
                        @click="handleGG(item, v, i)"
                    >{{v.name}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p style="margin-top: 5px;">价格：
            {{info.money}}</p>
          <p style="margin-top: 5px;">数量：
            <el-input-number
                v-model="num"
                :min="1"
                size="small"
                :max="9999999999"
                :controls="false"
                label="描述文字"
            >
            </el-input-number>
          </p>
        </div>
      </div>
      <div class="flex">
        <span style="color: #ff0000;">*</span>
        <p>收货地址：</p>
        <el-select
            size="small"
            style="width: 100%;"
            v-model="value1"
            clearable
            placeholder="请选择收货地址"
            value-key="id"
        >
          <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.fullName"
              :value="item">
          </el-option>
        </el-select>
      </div>
      <div class="flex">
        <span style="color: #ff0000;width: 7px;height: 1px;"></span>
        <p>买家留言：</p>
        <el-input
            size="small"
            style="width: 100%;"
            v-model="value2"
            placeholder="请输入买家留言"
        >
        </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="handleClose">取 消</el-button>
        <el-button :loading="loading" class="form-btn btn-blue" @click="doConfirm">下 单</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "orders",
  props: {
    row: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    xdType: {
      type: String,
      default: ''
    }
  },
  data(){
    return{
      value1: {},
      value2:'',
      options: [],
      info: {},
      num: 1,
      loading: false,
    }
  },
  mounted() {
    this.getInfo()
    this.getAddress()
  },
  methods: {
    // 点击规格(非图片)
    handleGG (item, v) {
      item.value = item.value.map((c) => {
        if (c.name === v.name) {
          c.checked = '1'
          c.newName = item.name + ':' + v.name
        } else {
          c.checked = '0'
          c.newName = ''
        }
        return { ...c }
      })
      this.screenItem()
    },
    // 筛选选择商品
    screenItem(){
      let data = this.info.specificationList
          .map((v) => {
            return v.value
          })
          .flat()
          .filter((c) => {
            return c.newName
          })
          .map((b) => {
            return b.newName
          })
      this.info.attrPriceList.forEach((v) => {
        if (data.length === this.info.specificationList.length) {
          if (this.isArrayEqual(data, v.sp_data.split(';'))) {
            // console.log(v)
            this.info.productInfo = v
            this.info.money = v.price || this.info.price
            this.info.taotianGoodsSkuId = v.taotianGoodsSkuId
            // initialUnitPrice.value = v.price
          }
        }
      })
      console.log(this.info)
    },
    // 判断数组内容相同不考虑顺序
    isArrayEqual (arr1, arr2){
      const a1 = arr1.map((i) => i)
      let a2 = arr2.map((i) => i)
      let tempArr = []
      if (a1.length !== a2.length) {
        return false
      } else {
        for (let i = 0; i < a1.length; i++) {
          if (a2.indexOf(a1[i]) !== -1) {
            a2.splice(a2.indexOf(a1[i]), 1)
            tempArr.push(a1[i])
          } else {
            tempArr = []
            break
          }
        }
        return tempArr.length === arr2.length
      }
    },
    async getInfo(){
      const params = {
        url: this.row.taobaoUrl,
        id: this.row.id,
        orderId: this.row.orderId,
      }
      if(this.xdType === '1688'){
        const res = await this.$http.get("shop/1688/goods/getGoodsInfo", {params})
        this.info = res.data.data
      }
      if(this.xdType === 'tb'){
        const res = await this.$http.get("taobaoShop/getGoodsInfo", {params})
        if(res.data.code === 200){
          this.info = res.data.data
        }else{
          this.$message.error(res.data.message);
        }
      }
      console.log(this.info)
    },
    async getAddress(){
      const res = await this.$http.get("shop/1688/goods/getAddress")
      this.options = res.data.data
      console.log(this.options)
    },
    async doConfirm(){
      console.log('this.info',this.value1)
      if(!this.info.money){
        return this.$message.error('请先选择规格');
      }
      if(Object.keys(this.value1).length === 0){
        return this.$message.error('请先选择地址');
      }
      // if(!this.value2){
      //   return this.$message.error('请先输入买家留言');
      // }
      // console.log('this.info1',this.value1)
      this.loading = true
      try {
        if(this.xdType === '1688'){
          const params = {
            message: this.value2,
            orderId: this.row.orderId,
            addressParam: {
              addressId: this.value1.id,
              fullName: this.value1.fullName,
              mobile: this.value1.mobilePhone,
              phone: this.value1.mobilePhone,
              postCode: this.value1.addressCode,
              cityText: this.value1.addressCodeText?.split(' ')[0] || '',
              provinceText: this.value1.addressCodeText?.split(' ')[1] || '',
              areaText: this.value1.addressCodeText?.split(' ')[2] || '',
              townText: this.value1.townName,
              address: this.value1.address,
              districtCode: this.value1.townCode,
            },
            alibabaTradeFastCargo: {
              offerId: this.info.code,
              specId: this.info?.productInfo?.specId,
              quantity: this.num,
            }
          }
          const res = await this.$http.post("shop/1688/goods/create1688Order",params)
          if(res.data.code === 200){
            this.$message.success(res.data.message);
            this.$options.confirm(true)
          }else{
            this.$message.error(res.data.message);
          }
          console.log(res.data)
        }
        if(this.xdType === 'tb'){
          const params = {
            goodsName: this.info.goodsName,//   商品名称
            goodsCount: this.num,//  商品数量
            price: this.info.money,//   商品单价
            taotianGoodsId: this.info.taotianGoodsId,//  淘天商品ID
            taotianGoodsSkuId: this.info.taotianGoodsSkuId,//  淘天商品skuID
            orderRemark: this.value2,//    买家留言
            orderAddressId: this.value1.id,//    地址id
            orderId: this.row.id,//     订单ID
          }
          console.log(params)
          const res = await this.$http.post("taobaoShop/createPurchaseOrder",params)
          if(res.data.code === 200){
            this.$message.success(res.data.message);
            this.$options.confirm(true)
          }else{
            this.$message.error(res.data.message);
          }
          console.log(res.data)
        }
      }finally {
        this.loading = false
      }
    },
    handleClose () {
      this.$options.cancel('cancel')
    }
  }
}
</script>

<style scoped lang="less">
.box{
  display: flex;
  img{
    width: 160px;
    height: 160px;
  }
  .right{
    margin-left: 15px;
    .title{
      font-size: 17px;
      margin: 5px 0;
    }
    .img1{
      width: 50px;
      height: 50px;
      margin-right: 5px;
      margin-bottom: 5px;
      cursor: pointer;
      border-radius: 5px;
      border: 2px solid #fff;
      &.active {
        border-radius: 5px;
        border: 2px solid #ff8726;
      }
    }
    .text{
      padding: 3px 6px;
      cursor: pointer;
      border-radius: 5px;
      border: 2px solid #fff;
      &.active {
        border-radius: 5px;
        border: 2px solid #ff8726;
      }
    }
  }
}
.flex{
  display: flex;
  align-items: center;
  margin-top: 10px;
  p{
    width: 75px;
  }
  .el-input{
    flex: 1;
  }
  .el-select{
    flex: 1;
  }
}

.set-title {
  ::v-deep .el-dialog__header {
    text-align: center;
  }
  ::v-deep .vue-barcode-element{
    width: 100%!important;
  }
  ::v-deep .el-dialog__body{
    padding-top: 10px;
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ::v-deep .el-input-number--medium {
    width: 100%;
  }
  ::v-deep .el-input-number.is-without-controls .el-input__inner {
    text-align: left;
  }
}
</style>
